function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import clsx from 'clsx';
import { ResizeObserved, Observed } from "../../watchers/resize";
import { a, config, useTransition } from '@react-spring/web';
import { useSlidesPrevious } from "./use-slides.hook";
export const Slides = props => {
  const {
    items,
    current,
    animation,
    className,
    initialSlide = false
  } = props;
  const [height, setHeight] = React.useState(0);
  const heights = React.useRef(items.map(() => 0));
  const {
    previous,
    firstSliding
  } = useSlidesPrevious(current);
  React.useEffect(() => {
    setHeight(heights.current[current]);
  }, [current]);
  const transitions = useTransition(items[current], {
    unique: true,
    config: animation !== null && animation !== void 0 ? animation : config.default,
    from: {
      transform: !firstSliding || initialSlide ? `translate3d(${current - previous > 0 ? 100 : -100}%,0,0)` : 'translate3d(0%,0,0)',
      position: 'static',
      height: `${heights.current[previous]}px`,
      opacity: 0
    },
    enter: {
      transform: 'translate3d(0%,0,0)',
      position: 'static',
      height: `${heights.current[current] || heights.current[previous]}px`,
      opacity: 1
    },
    update: {
      transform: 'translate3d(0%,0,0)',
      position: 'static',
      height: `${height}px`,
      opacity: 1
    },
    leave: {
      transform: `translate3d(${previous - current > 0 ? 100 : -100}%,0,0)`,
      zIndex: 1,
      opacity: 0,
      position: 'absolute',
      height: `${heights.current[current]}px`
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(className),
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "transition-slide",
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, transitions((style, item) => /*#__PURE__*/React.createElement(a.div, {
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: '100%'
    })
  }, /*#__PURE__*/React.createElement(ResizeObserved, {
    type: Observed.HEIGHT,
    onChange: resize => {
      if (item.key === current) {
        heights.current[current] = resize.height;
        setHeight(resize.height);
      }
    }
  }, /*#__PURE__*/React.createElement(item.slide, null))))));
};